module.exports = __webpack_public_path__ + "img/product_desk_15.cb2a3e55.jpg";